import { useState, useEffect } from 'react';

// Safari < 14 only supports the deprecated addListener/removeListener API.
export const subscribeMediaQuery = (mql, handler) => {
  if (mql.addEventListener) {
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }

  mql.addListener(handler);
  return () => mql.removeListener(handler);
};

// Whether the document's viewport matches `query` right now, kept current by
// the query's own change events (they fire only when the boundary is crossed,
// so resizing inside one tier costs nothing). Reads the current document's
// viewport, like every media query - useViewMode explains when that is not
// the device's.
const useMediaQuery = (query) => {
  const [mql] = useState(() => window.matchMedia(query));
  const [matches, setMatches] = useState(() => mql.matches);

  useEffect(() => subscribeMediaQuery(mql, () => setMatches(mql.matches)), [mql]);

  return matches;
};

export default useMediaQuery;
